import { useCompanies } from '@centecomm/portal-service-react';
import { SpinningLoader } from 'Icons/Animated';
import { FlexWrapper } from 'Shared/FlexWrapper';
import { PageWrapper } from 'Shared/PageWrapper';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { IsolatedLayout } from '../Layouts';
import useSubscription from '../Subscription/useSubscription';

function FriendlyCompanyHandler(): React.ReactElement {
    const { push } = useHistory();
    const { friendlyName } = useParams<{ friendlyName: string }>();
    const { getCompanyOrgId } = useCompanies();

    const { setOrganization } = useSubscription();

    const [hasError, toggleHasError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        (async (): Promise<void> => {
            try {
                const { auth0OrgId } = await getCompanyOrgId(friendlyName);

                setOrganization(auth0OrgId);
                push('/');
            } catch (error) {
                toggleHasError(true);
                setErrorMessage(error);
            }
        })();
    }, [friendlyName]);

    return (
        <IsolatedLayout>
            <PageWrapper>
                <FlexWrapper align="center" justify="center" fullWidth column style={{ minHeight: 'calc(95vh - 4rem)' }}>
                    {hasError ? (
                        <>
                            <h1 style={{ marginTop: 0 }}>Login Error</h1>
                            <p style={{ marginBottom: '1rem' }}>
                                We were not able to access your Company&apos;s information
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                Please visit our <Link to="/login">Login Page</Link> to enter your email directly.
                            </p>
                            {errorMessage.length > 0 && (
                                <FlexWrapper
                                    align="center"
                                    justify="center"
                                    column
                                    style={{
                                        padding: '1rem',
                                        borderRadius: '0.25rem',
                                        border: '1px solid var(--color-LightGrey)',
                                        backgroundColor: 'var(--color-OffWhite)',
                                    }}
                                >
                                    <p style={{ marginBottom: '0.5rem' }}>
                                        <b>Error Message:</b>
                                    </p>
                                    <p>{errorMessage}</p>
                                </FlexWrapper>
                            )}
                        </>
                    ) : (
                        <>
                            <h1 style={{ marginTop: 0 }}>Welcome!</h1>
                            <p style={{ marginBottom: '1.5rem' }}>We are working to direct you to the correct place.</p>
                            <SpinningLoader aspect="2rem" />
                        </>
                    )}
                </FlexWrapper>
            </PageWrapper>
        </IsolatedLayout>
    );
}

export default FriendlyCompanyHandler;
